import React from "react";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid2";
import FallbackTypography from "src/components/shared/FallbackTypography";
import { Typography } from "@mui/material";

const GuestInformation = () => {
  const { clientVoucherDetails } = useSelector((state) => state.reservationsSummaryReducer);

  return (
    <Grid container rowSpacing={1} mt={5} ml={7}>
      <Grid size={6}>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item size={6}>
            <Typography variant="body1" m={1}>
              Party Names - If more than one pax (names)
            </Typography>

            <Grid container direction="column">
              {clientVoucherDetails.Guests
                ?.filter(guest => guest?.Name)
                ?.map((guest, index) => (
                  <Grid item key={index}>
                    <FallbackTypography variant="body1" m={1} value={`${index + 1} - ${guest.Name} ${guest.Age ? ` (${guest.Age} yrs)` : ''}`} />
                  </Grid>
                ))
              }
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default GuestInformation;
